import styled from 'styled-components'

const CategoriesHorizontalSliderStyle = styled.div`
    --iconSize: var(--sp6x);

    position: relative;
    user-select: none;

    .action-btn {
        position: absolute;
        top: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: translate3d(0, -50%, 0);
        -webkit-transform: translate3d(0, -50%, 0);
        font-size: var(--pS);
        z-index: 3;
        width: var(--iconSize);
        height: var(--iconSize);
        border-radius: var(--sp1x);
        box-shadow: 0px 3px 12px #15233B52;
        transition: transform var(--trTime);
        -webkit-overflow-scrolling: auto !important;
        cursor: pointer;

        &.action-btn-left {
            left: 0;

            i {
                display: inline-block;
                transform: rotate(180deg);
            }
        }

        &.action-btn-right {
            right: 0;    
        }

        &.swiper-button-disabled {
            opacity: 0;
            pointer-events: none;
        }

        &:hover {
            transform: translateY(-50%) scale(1.05);
        }
    } 

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL})  and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
        --iconSize: var(--sp5x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM})  and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
        --iconSize: var(--sp4x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS})  and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
        --iconSize: var(--sp4x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS})  and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
        --iconSize: var(--sp4x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize})  and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
        --iconSize: var(--sp4x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS})  and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
        --iconSize: var(--sp4x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.MobileSize}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
        --iconSize: var(--sp4x);
    }

    @media only screen and (max-width: ${({ theme }) => theme.mediaQuery.MobileSizeMin}) {
        --iconSize: var(--sp4x);
    }
`

export default CategoriesHorizontalSliderStyle